import { useLocation, useHistory } from "react-router-dom";

import { maskPhoneNumber } from "../../Utils";
import { env } from "../../Constants";

import { PathRoutesType } from "../../routes";

import {
  FeedbackScreen,
  FeedbackScreenProps,
  ContactsProps,
} from "./Feedback.screen";
import { useSendWhatsApp } from "./services/feedback.useSendWhatsapp";

export enum ScreensEnum {
  RESGISTRATION_PERFORMED = "registration_performed",
  RESGISTRATION_DENIED = "registration_denied",
  RESGISTRATION_UNDER_ANALYSIS = "registration_under_analysis",
  UNEXPECTED_PROBLEMA = "unexpected_problem",
  OPERATION_PERFORMED_SUCCESSFULLY = "operation_performed_successfully",
  ALREADY_REGISTERED_USER = "already_registered_user",
  SOME_DATA_IS_MISSING = "some_data_is_missing",
  USER_NOT_FOUND = "user_not_found",
  RESET_SUCCESS = "reset_success",
}

interface LocationState {
  type: ScreensEnum;
  origin?: PathRoutesType;
}

export const FeedbackController = () => {
  const location = useLocation<LocationState>()?.state;
  const type = location?.type || ScreensEnum.UNEXPECTED_PROBLEMA;
  const origin = location?.origin || "/login";

  useSendWhatsApp({ type });

  const history = useHistory();

  const contacts: ContactsProps[] = [
    {
      contact: maskPhoneNumber("21996181222") || "",
      name: "WhatsApp",
      type: "whatsapp",
      link: () => {
        window.location.href =
          "https://api.whatsapp.com/send?phone=5521996181222&text=Preciso%20de%20ajuda%20";
      },
    },
  ];

  const screenReducer = (): FeedbackScreenProps => {
    switch (type) {
      case ScreensEnum.RESGISTRATION_PERFORMED:
        return {
          title: "Cadastro realizado",
          description: "Você será redirecionado\npara o Whatsapp :)",
          buttons: [
            {
              text: "Ir para o Whatsapp",
              params: {
                onClick: () =>
                  (window.location.href =
                    env.take.whatsapp.url + env.take.whatsapp.text.signUp),
              },
            },
          ],
          image: "sucess",
          type: "success",
        };

      case ScreensEnum.RESGISTRATION_DENIED:
        return {
          title: "Não conseguimos\nconfirmar seus dados",
          description:
            "Tente refazer o cadastro daqui 3 minutos, ou poderemos te ajudar atravás da central",
          buttons: [
            {
              text: "Ok, entendi",
              params: {
                onClick: () => {
                  history.replace({
                    pathname: "/signup",
                  });
                },
              },
            },
          ],
          image: "supportHelping",
          type: "denied",
          contacts,
        };
      case ScreensEnum.RESGISTRATION_UNDER_ANALYSIS:
        return {
          title: "Em análise",
          description:
            "Estamos analisando seus dados,\niremos te avisar assim que terminarmos!",
          image: "analysisPaper",
          type: "warning",
          contacts,
        };
      case ScreensEnum.UNEXPECTED_PROBLEMA:
        return {
          title: "Problema inesperado :(",
          description: "Por favor, tente novamente\nem alguns instantes",
          buttons: [
            {
              text: "Voltar para o início",
              params: {
                onClick: () => {
                  if (origin === "/login") {
                    history.replace({
                      pathname: "/login",
                    });
                    return;
                  }

                  if (origin === "/signup") {
                    history.replace({
                      pathname: "/signup",
                    });
                    return;
                  }
                },
              },
            },
          ],
          image: "disconnectedInternetCable",
          type: "denied",
        };
      case ScreensEnum.OPERATION_PERFORMED_SUCCESSFULLY:
        return {
          title: "Sucesso :)",
          description: "Você será redirecionado\npara o Whatsapp :)",
          buttons: [
            {
              text: "Ir para o Whatsapp",
              params: {
                onClick: () =>
                  (window.location.href =
                    env.take.whatsapp.url + env.take.whatsapp.text.login),
              },
            },
          ],
          image: "successCellphone",
          type: "success",
        };
      case ScreensEnum.ALREADY_REGISTERED_USER:
        return {
          title: "Já cadastrado!",
          description:
            "Por favor, faça o login com usuário e senha, ou entre em contato com a central de relacionamento que iremos te ajudar :)",
          buttons: [
            {
              text: "Ir para o Whatsapp",
              params: {
                onClick: () => {
                  window.location.href = env.take.whatsapp.url + "&text=Login";
                },
              },
            },
          ],
          image: "alreadyCreated",
          type: "warning",
          contacts,
          headerNavigation: {
            onClick: () => history.goBack(),
          },
        };

      case ScreensEnum.SOME_DATA_IS_MISSING:
        return {
          title: "Faltam alguns dados...",
          description:
            "Vamos te ajudar a recuperar\nsua senha ou login pelo\nnosso canal do whatsapp. ",
          buttons: [
            {
              text: "Ok, vamos lá",
              params: {
                onClick: contacts[0].link,
              },
            },
          ],
          image: "someDataMissing",
          type: "warning",
          headerNavigation: {
            onClick: () => history.goBack(),
          },
        };

      case ScreensEnum.USER_NOT_FOUND:
        return {
          title: "Usuário não encontrado",
          description: "Por favor, volte e revise\nsuas informações",
          buttons: [
            {
              text: "Ok, vamos lá",
              params: {
                onClick: history.goBack,
              },
            },
          ],
          image: "userNotFound",
          type: "warning",
        };

      case ScreensEnum.RESET_SUCCESS:
        return {
          title: "Tudo certo!",
          description: "Sua nova senha foi criada",
          buttons: [
            {
              text: "Ok, fazer login",
              params: {
                onClick: () => {
                  history.replace({
                    pathname: "/login",
                  });
                },
              },
            },
          ],
          image: "personWithKey",
          type: "success",
        };
    }
  };

  const handlers: FeedbackScreenProps = {
    ...screenReducer(),
  };

  return <FeedbackScreen {...handlers} />;
};
